module.exports = __webpack_public_path__ + "static/etnetera-494a83f00197640b6af178dc408b56c3.png";